"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserConverter = void 0;
const LinkEntity_1 = require("../../common/model/LinkEntity");
class UserConverter {
    static convert(userEntity) {
        return {
            id: userEntity.id,
            firstName: userEntity.firstName,
            lastName: userEntity.lastName,
            email: userEntity.email,
            jobTitle: userEntity.jobTitle,
            audiences: userEntity.audiences,
            desiredContent: userEntity.desiredContent,
            discoveryMethods: userEntity.discoveryMethods,
            features: userEntity.features,
            accessExpiresOn: userEntity.accessExpiresOn
                ? new Date(userEntity.accessExpiresOn)
                : undefined,
            account: userEntity.account
                ? {
                    id: userEntity.account?.id,
                    name: userEntity.account?.name,
                    marketingInformation: userEntity.account?.marketingInformation,
                    products: userEntity.account.products?.map((productEntity) => productEntity),
                    type: userEntity.account?.type,
                    createdAt: new Date(userEntity.account.createdAt),
                    logoUrl: userEntity.account.logoUrl,
                }
                : undefined,
            hasAcceptedTermsAndConditions: userEntity.hasAcceptedTermsAndConditions,
            links: {
                self: userEntity._links?.self
                    ? new LinkEntity_1.Link(userEntity._links.self)
                    : undefined,
                updateUserAccount: userEntity._links?.updateUserAccount
                    ? new LinkEntity_1.Link(userEntity._links.updateUserAccount)
                    : undefined,
            },
        };
    }
    static convertUsers(response) {
        const entities = response._embedded.users;
        return entities.map(this.convert);
    }
}
exports.UserConverter = UserConverter;
//# sourceMappingURL=UserConverter.js.map